import type { Agency } from "@features/user"
import {
  type Currency,
  formatCurrencyParts,
} from "../../../helpers/formatCurrencyBRL"
import type { Offer } from "../../offersList/offersListTypes"

const buildHtmlGea = (
  offers: Offer[],
  currency: Currency,
  headerUrl?: string,
  agency?: Agency,
) => {
  const agency_logo =
    "https://grupogea.pt/img/agencies/b9b022c721a2a73df6623d2c001401cf.png"
  const items = offers
    .map((o) => {
      const price = formatCurrencyParts(o.LeadInPrice, currency)
        .map(({ value }) => value)
        .join("")

      return `
        <table border="0" cellpadding="0" cellspacing="0" width="100%" style="border-collapse: collapse;">
    <tbody>
      <tr>
        <td align="center">
          <table border="0" cellpadding="0" cellspacing="0" id="isPasted"
            style="background-color: rgb(248, 248, 248); border-collapse: collapse; width: 800px;">
            <tbody>
              <tr>
                <td align="center" style="background-color: rgb(255, 255, 255);">
                  <table border="0" cellpadding="0" cellspacing="0" style="border-collapse: collapse; width: 650px;">
                    <tbody>
                      <tr>
                        <td height="50"><br></td>
                      </tr>
                      <tr>
                        <td align="center">
                          <table width="100%" border="0" cellpadding="0" cellspacing="0"
                            style="border-collapse: collapse;">
                            <tbody>
                              <tr>
                                <th align="left" width="325">
                                  <table align="left" width="295" border="0" cellpadding="0" cellspacing="0"
                                    style="border-collapse: collapse; width: 295px;">
                                    <tbody>
                                      <tr>
                                        <td style="line-height: 10px; height: 10px; font-size: 0px;">&nbsp;</td>
                                      </tr>
                                      <tr>
                                        <td
                                          style="font-family: Lato, Arial, Helvetica, sans-serif; font-size: 25px; color: rgb(18, 18, 18); font-weight: 600;">${o.OfferTitle}</td>
                                      </tr>
                                      <tr>
                                        <td style="line-height: 10px; height: 10px; font-size: 0px;">&nbsp;</td>
                                      </tr>
                                      <tr>
                                        <td>
                                          <table border="0" cellpadding="0" cellspacing="0"
                                            style="border-collapse: collapse; width: 200px;">
                                            <tbody>
                                              <tr>
                                                <td align="left"
                                                  style="font-family: 'Open Sans', Arial, Helvetica, sans-serif; font-size: 25px; color: rgb(1, 103, 243); font-weight: 700;">
                                                  ${price}<br></td>
                                                <td width="10">&nbsp;</td>
                                                <td align="left"
                                                  style="font-family: 'Open Sans', Arial, Helvetica, sans-serif; font-size: 14px; color: rgb(94, 94, 94); font-weight: 700;">
                                                  ${o.Nights} noite(s)<br></td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>&nbsp;</td>
                                      </tr>
                                      <tr>
                                        <td><br></td>
                                      </tr>
                                      <tr>
                                        <td
                                          style="font-family: 'Open Sans', Arial, Helvetica, sans-serif; font-size: 13px; color: rgb(130, 130, 130); line-height: 20px; font-weight: 400;">${o.Description}<br></td>
                                      </tr>
                                      <tr>
                                        <td height="20">&nbsp;</td>
                                      </tr>
                                      <tr>
                                        <td>
                                          <table cellpadding="0" cellspacing="0">
                                            <tbody>
                                              <tr>
                                                <td align="center" width="200" height="50"
                                                  style="background-color: rgb(1, 103, 243); color: rgb(255, 255, 255); font-size: 13px; font-family: 'Open Sans', Arial, Helvetica, sans-serif; text-decoration: none; letter-spacing: 0.15px; border-radius: 25px; font-weight: 400;">
                                                  <a href="${o.URL}"
                                                    target="_blank" rel="noopener noreferrer"
                                                    style="color: rgb(255, 255, 255); text-decoration: none;">Reservar</a>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td height="30">&nbsp;</td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </th>
                                <th width="325">
                                  <table align="right" width="325" border="0" cellpadding="0" cellspacing="0"
                                    style="border-collapse: collapse; width: 325px;">
                                    <tbody>
                                      <tr>
                                        <td align="center"><img width="325" alt="${o.Description}" src="${o.ImageURL}"
                                            style="width: 325px;"></td>
                                      </tr>
                                      <tr>
                                        <td height="30">&nbsp;</td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </th>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
    </tbody>
  </table>`
    })
    .join("")

  const footer = `<table border="0" cellpadding="0" cellspacing="0" style="border-collapse: collapse; width: 100%;">
  <tbody><tr><td align="center">
  <table bgcolor="#1d1d1d" border="0" cellpadding="0" cellspacing="0" style="border-collapse: collapse; width: 800px; background: rgb(29, 29, 29);"><tbody>
  <tr><td align="center"><table border="0" cellpadding="0" cellspacing="0" style="border-collapse: collapse; width: 650px;">
  <tbody>
  <tr>
  <td height="50"> &nbsp;</td>
  </tr>
  <tr>
  <td align="center">
  <img src="${agency_logo}" alt="${agency?.name}" style="max-height: 120px;"></td></tr><tr><td height="30">&nbsp;</td></tr><tr><td align="center" style="font-family: 'Open Sans', Arial, Helvetica, sans-serif; font-size: 13px; color: rgb(101, 101, 101); line-height: 21px; font-weight: 400;">${agency?.address}, ${agency?.postal_code} <br>Telf.: ${agency?.phone_number}<br> Email: ${agency?.email}<br></td></tr><tr><td height="30">&nbsp;</td></tr><tr><td align="center"><table border="0" cellpadding="0" cellspacing="0" width="200" style="border-collapse: collapse;"><tbody><tr><td style="width: 0.9231%;"> &nbsp;</td><td style="width: 5.9998%;"><br></td><td style="width: 5.0002%;"><br></td><td><br></td><td style="width: 5.0001%;"> &nbsp;</td><td style="width: 5.9999%;"><br></td><td style="width: 5%;"> &nbsp;</td><td style="width: 42%;"><br></td><td style="width: 10px;"> &nbsp;</td></tr></tbody></table></td></tr><tr><td height="50"><br></td></tr></tbody></table></td></tr></tbody></table></td></tr></tbody></table>`

  return `
  <!DOCTYPE html>
<html>
<head>
  <style>
    @import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,600i,700,700i,800,800i);
    @import url(https://fonts.googleapis.com/css?family=Lato:300,300i,400,400i,600,600i,700,700i,800,800i);
    @import url(https://fonts.googleapis.com/css?family=Roboto:300,300i,400,400i,600,600i,700,700i,800,800i);

    html {
      width: 100%;
    }

    body {
      margin: 0;
      padding: 0;
      width: 100%;
      -webkit-text-size-adjust: none;
      -ms-text-size-adjust: none;
    }

    img {
      display: block !important;
      border: 0;
      -ms-interpolation-mode: bicubic;
    }

    .ReadMsgBody {
      width: 100%;
    }

    .ExternalClass {
      width: 100%;
    }

    .ExternalClass,
    .ExternalClass p,
    .ExternalClass span,
    .ExternalClass font,
    .ExternalClass td,
    .ExternalClass div {
      line-height: 100%;
    }

    .images {
      display: block !important;
      width: 100% !important;
    }

    p {
      margin: 0 !important;
      padding: 0 !important;
    }

    a {
      text-decoration: none !important;
    }

    img[class=follow],
    td[class=follow] {
      width: 100% !important;
      height: auto !important
    }

    @media only screen and (max-width: 480px) {
      table[class=container-48] {
        width: 100% !important;
        min-width: 100% !important
      }

      table[class=boxed] {
        width: 90% !important;
        min-width: 90% !important
      }

      th[class=column] {
        box-sizing: border-box;
        display: inline-block !important;
        line-height: inherit !important;
        width: 100% !important;
        word-break: break-word;
      }

      td[class=loss] {
        display: none !important
      }
    }
  </style>
</head>

<body data-gr-ext-installed="" data-new-gr-c-s-check-loaded="14.1190.0" data-new-gr-c-s-loaded="14.1190.0">
  <table border="0" cellpadding="0" cellspacing="0" style="border-collapse: collapse; width: 100%;">
    <tbody>
      <tr>
        <td align="center">
          <table border="0" cellpadding="0" cellspacing="0" class="container-48"
            style="border-collapse: collapse; width: 800px; min-width: 800px;">
            <tbody>
              <tr>
                <td align="center" bgcolor="#ffffff">
                  <table align="center" border="0" cellpadding="0" cellspacing="0" class="container-48" width="100%"
                    style="border-collapse: collapse; width: 650px;">
                    <tbody>
                      <tr>
                        <td height="25"><img
                            src="${agency_logo}"
                            alt="${agency?.name}"
                            style="border: 0px; max-width: none; position: relative; cursor: pointer; padding: 0px 1px; color: rgb(0, 0, 0); font-family: Times; font-size: medium; font-style: normal; font-variant-ligatures: normal; font-variant-caps: normal; font-weight: 400; letter-spacing: normal; orphans: 2; text-align: center; text-indent: 0px; text-transform: none; widows: 2; word-spacing: 0px; -webkit-text-stroke-width: 0px; white-space: normal; background-color: rgb(29, 29, 29); text-decoration-thickness: initial; text-decoration-style: initial; text-decoration-color: initial; display: block; vertical-align: top; margin: 5px auto; max-height: 120px;"><br>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
    </tbody>
  </table>
  ${headerUrl
      ? `<table align="center">
          <tbody>
            <tr>
              <td>
                <img src="${headerUrl}"
                  style="width: 800px; max-width: 800px; display: block; vertical-align: top; margin: 5px auto; text-align: center; float: none;">
              </td>
            </tr>
          </tbody>
        </table>`
      : ""
    }
  
  ${items}

  ${footer}
</body>

</html>`
}

export default buildHtmlGea
